import { Bar, mixins } from 'vue-chartjs'
import { commaFormatString, isDecimal } from '@/helpers'
import truncateAmount from '@/filters/truncateAmount'

const { reactiveProp } = mixins
// TODO: find out why the reactiveprop mixin ignores the options after the first render
export default Bar.extend({
  mixins: [reactiveProp],
  data () {
    return {
      options: {
        responsive: true,
        maintainAspectRatio: false,
        animation: {
          duration: 0
        },
        legend: {
          display: false
        },
        layout: {
          padding: {
            left: 0,
            right: 15,
            top: 0,
            bottom: 10
          }
        },
        scales: {
          xAxes: [{
            // barSize: 60,
            barPercentage: 0.6,
            barSpacing: 20,
            gridLines: {
              drawBorder: false,
              zeroLineColor: '#0052E7'
            },
            ticks: {
              fontSize: 12,
              fontStyle: 'bold',
              callback: function (value) {
                return value
              }
            }
          }],
          yAxes: [{
            gridLines: {
              display: true,
              zeroLineColor: '#0052E7'
            },
            ticks: {
              padding: 4,
              fontSize: 12,
              callback: function (value) {
                return isDecimal(value) ? '' : truncateAmount(value)
              }
            }
          }]
        },
        tooltips: {
          displayColors: false,
          mode: 'index',
          intersect: false,
          callbacks: {
            label: function (tooltip, data) {
              return `${data.datasets[tooltip.datasetIndex].label}: ${commaFormatString(String(tooltip.yLabel))}`
            }
          }
        }
      }
    }
  },
  mounted () {
    // this.chartData
    this.renderChart(this.chartData, this.options)
  }
})



// WEBPACK FOOTER //
// ./src/app/appComponents/oldWorkbench/propertyEngagementReach/PropertyEngagementReachGraph.js